import { UserType } from "utils/constants";
import Location from "./Location";
import ServiceProvider from "./ServiceProvider";
import TenantManagement from "./TenantManagement";

/**
 * The reference lists AuthContext puts in the common store at login: the SPs,
 * tenants and locations the caller may see, which pages read names and
 * dropdown choices from, plus the caller's own spType.
 *
 * Resolves to `{ serviceProviders, tenants, locations, spType }`. A list that
 * fails to load comes back empty rather than failing the login. The API scopes
 * each list from the token, so the only per-type choice here is which lists
 * can hold anything at all.
 */
export default async function loadReferenceData(loginData) {
  const type = loginData?.type;
  const isSPCaller = [UserType.NTTsp, UserType.ServiceProvider].includes(type);
  const isTenantSide = [UserType.Tenant, UserType.Location].includes(type);
  if (!isSPCaller && !isTenantSide) {
    return { serviceProviders: [], tenants: [], locations: [], spType: "" };
  }

  const [serviceProviders, tenants, locations] = await Promise.all([
    isSPCaller ? items(ServiceProvider.listSP()) : [],
    type !== UserType.Location ? items(TenantManagement.listTenants()) : [],
    items(Location.listLocation()),
  ]);
  return {
    serviceProviders,
    tenants,
    locations,
    spType:
      serviceProviders.find((sp) => sp.groupName === loginData.spID)?.spType ??
      "",
  };
}

const items = (promise) =>
  promise
    .then((page) => page.items)
    .catch((error) => {
      console.error("[reference data] failed to load", error);
      return [];
    });
